import { Download, AlertTriangle, BarChart2, MessageSquare, Undo2, Redo2, Check } from 'lucide-react';
import { usePrototype1 } from '../Prototype1Context';
import DraftBody from '../../_shared/DraftBody';

const SECTION_ID = 'college-eligibility';

const Screen04ChatPanelClosed = () => {
  const { goToScreen, drafts, approveSection, undoDraft, redoDraft, canUndoDraft, canRedoDraft } = usePrototype1();
  const draft = drafts[SECTION_ID] ?? '';
  const canUndo = canUndoDraft(SECTION_ID);
  const canRedo = canRedoDraft(SECTION_ID);
  const showApprove = canUndo;

  const handleApprove = () => {
    approveSection(SECTION_ID);
    goToScreen('05-dashboard-report-overview');
  };

  return (
    <div className="flex h-full w-full bg-[#fafafa] font-['Inter']">
      <div className="flex flex-col flex-1 min-w-0">
        <div className="flex items-center justify-between px-6 h-14 border-b border-[#e5e5e5] shrink-0">
          <div className="flex items-center gap-2 text-sm">
            <button type="button" onClick={() => goToScreen('01-dashboard')} className="text-[#737373] hover:underline">
              Issaquah School District
            </button>
            <span className="text-[#737373]">/</span>
            <span className="text-[#737373]">Class of 2025</span>
            <span className="text-[#737373]">/</span>
            <span className="font-medium text-[#0a0a0a]">College Eligibility</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center px-2.5 py-0.5 text-xs font-semibold text-white rounded-full bg-[#f59e0b]">
              Drafting
            </span>
            <button
              type="button"
              className="flex items-center gap-1.5 px-3 py-1.5 text-[13px] font-medium border border-[#e5e5e5] rounded-md bg-white hover:bg-gray-50 transition-colors"
            >
              <Download className="w-3.5 h-3.5" />
              Export Draft
            </button>
          </div>
        </div>

        <div className="flex flex-col flex-1 min-h-0 bg-[#fafafa]">
          <div className="flex items-center justify-between px-6 py-4 border-b border-[#e5e5e5] shrink-0">
            <div className="flex flex-col gap-1">
              <span className="text-base font-semibold text-[#0a0a0a]">Section 2B: College Eligibility</span>
              <span className="text-[13px] text-[#737373]">AI is drafting — focusing on equity gaps analysis</span>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => goToScreen('03-equity-gaps-drafting')}
                className="flex items-center gap-1.5 px-3 py-1.5 text-[13px] font-medium text-[#737373] hover:bg-[#f5f5f5] rounded-md transition-colors"
              >
                <MessageSquare className="w-4 h-4" />
                AI Chat
              </button>
              <button
                type="button"
                onClick={() => undoDraft(SECTION_ID)}
                disabled={!canUndo}
                className="flex items-center gap-1.5 px-3 py-1.5 text-[13px] font-medium text-[#737373] hover:bg-[#f5f5f5] rounded-md transition-colors disabled:opacity-40 disabled:hover:bg-transparent disabled:cursor-not-allowed"
              >
                <Undo2 className="w-4 h-4" />
                Undo
              </button>
              <button
                type="button"
                onClick={() => redoDraft(SECTION_ID)}
                disabled={!canRedo}
                className="flex items-center gap-1.5 px-3 py-1.5 text-[13px] font-medium text-[#737373] hover:bg-[#f5f5f5] rounded-md transition-colors disabled:opacity-40 disabled:hover:bg-transparent disabled:cursor-not-allowed"
              >
                <Redo2 className="w-4 h-4" />
                Redo
              </button>
              {showApprove && (
                <button
                  type="button"
                  onClick={handleApprove}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-[13px] font-medium text-white bg-[#171717] hover:bg-[#2a2a2a] rounded-md transition-colors"
                >
                  <Check className="w-4 h-4" />
                  Approve Section
                </button>
              )}
            </div>
          </div>

          <div className="flex flex-col gap-5 p-8 overflow-y-auto flex-1">
            <h1 className="text-[22px] font-bold text-[#0a0a0a]">College Eligibility</h1>
            <h2 className="text-[17px] font-semibold text-[#0a0a0a]">Equity Gaps in College Eligibility</h2>
            <div className="flex items-center gap-2.5 px-4 py-3 rounded-md bg-[#fef3c7] border border-[#f59e0b]/30">
              <AlertTriangle className="w-4 h-4 text-[#d97706] shrink-0" />
              <p className="text-[13px] text-[#92400e] font-medium leading-[1.5]">
                AI-highlighted: This paragraph addresses the core equity gaps you asked to focus on
              </p>
            </div>
            <DraftBody text={draft} />
            <div className="flex flex-col items-center justify-center h-[140px] rounded-lg bg-[#f5f5f5] border border-[#e5e5e5] gap-2">
              <BarChart2 className="w-7 h-7 text-[#a3a3a3]" />
              <span className="text-[13px] font-medium text-[#737373]">
                Figure 2.1 — College Eligibility Rate by Student Subgroup
              </span>
              <span className="text-[11px] text-[#737373]">Visualization</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Screen04ChatPanelClosed;
